/** Skip cold-start session bootstrap on public auth pages (login runs bootstrap after sign-in). */
export function shouldSkipColdSessionBootstrap(pathname: string): boolean {
  const path = pathname.toLowerCase();
  if (path === '/register' || path.startsWith('/register/')) {
    return true;
  }
  if (path.includes('forgot-password') || path.includes('reset-password')) {
    return true;
  }
  if (path === '/login' || path === '/sign-in' || path.endsWith('/login') || path.endsWith('/sign-in')) {
    return true;
  }
  if (path === '/oauth/callback' || path === '/identity/oauth/callback') {
    return true;
  }
  return false;
}

/** True while the app has not finished attempting cookie session restore (page refresh). */
export function isSessionRestorePending(
  initialized: boolean,
  sessionLoading: boolean,
  sessionLoaded: boolean,
  isAuthenticated: boolean,
): boolean {
  if (!initialized) {
    return true;
  }
  return sessionLoading && !sessionLoaded && !isAuthenticated;
}
